import React from "react";
import Components from "../../components";
import { useLocation } from "react-router-dom";

const Order = ({ data, dataSetter }) => {
  const location = useLocation();
  const o = location.state.order;
  
  return (
    <div>
      <Components.PageHeader
        id="page-header"
        label="Page Header"
        title={`Sipariş Detayı ${o.orderNumber}`}
        safeArea={data?.system?.safeArea}
        pixelRatio={data?.system?.pixelRatio}
      />
      <Components.Order
        id="order"
        label="Order"
        data={data}
        dataSetter={dataSetter}
      />
    </div>
  );
};

export default Order;
